export default __webpack_public_path__ + "static/media/logoutIconWhite.3600fdba.png";